module.exports = __webpack_public_path__ + "static/TheMetSans-Bold-880fe5764103868f56aac82649f8db09.woff";